/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import axios from 'axios'
import { FC, useCallback, useMemo, useState } from 'react'

import { OS_API_KEY } from '../../constants'
import { NewsletterData } from '../../constants/newsletter'
import { useI18n } from '../../hooks'
import { useAppSelector } from '../../store'
import { validateEmail } from '../../utils'
import { openSnackbar } from '../snackbar'
import './index.css'

const NewsletterSubsForm: FC = () => {
  const dataSet = NewsletterData.Status

  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<string>(dataSet[0])
  const [error, setError] = useState('')

  const selectId = 'newsletter-status-selection-id'

  const { settings } = useAppSelector((state) => state.appConfigReducer)
  const { locale } = settings
  const { t } = useI18n()

  const clearFields = useCallback(() => {
    setEmail('')
    setStatus(dataSet[0])
  }, [dataSet])

  const subsFormContent = useCallback(
    (): {
      title: string
      subTitle: string
      status: ('Student' | 'Teacher' | 'Other')[]
      displayValue: { Student: string; Teacher: string; Other: string }
    } => ({
      title: t('NewsletterSubscription_title'),
      subTitle: t('NewsletterSubscription_subTitle'),
      status: ['Student', 'Teacher', 'Other'],
      displayValue: {
        Student: t('NewsletterSubscription_option_student'),
        Teacher: t('NewsletterSubscription_option_teacher'),
        Other: t('NewsletterSubscription_option_other'),
      },
    }),
    [t, locale]
  )
  const handleSubscribe = useCallback(async () => {
    if (!email || !validateEmail(email)) {
      setError(t('Common_EnterValidEmail'))
    } else {
      const honeypot = document.querySelector('.honeypot-email') as HTMLInputElement
      if (honeypot && !honeypot.value) {
        try {
          const data = {
            Email: email,
            user_group: status,
            status: 'subscribed',
            statusDate: new Date(),
          }
          await axios({
            method: 'post',
            url: 'https://api.omnisend.com/v3/contacts',
            headers: {
              'X-API-KEY': OS_API_KEY,
              'Content-Type': 'application/json',
            },
            data,
          })

          openSnackbar(`${t('Common_thankYou')}, ${email} ${t('NewsletterSubscription_subscribedMessage')}`, 6, 'topRight', 'success')
          clearFields()
        } catch (e) {
          openSnackbar(`${t('NewsletterSubscription_subscribeError')}`, 6, 'topRight', 'failure')
        }
      }
      setError('')
    }
  }, [clearFields, email, status])
  return useMemo(
    () => (
      <>
        <div className="newsletter-wrapper" role="form">
          <div className="newsletter-subscription">
            <div className="newsletter-message">
              <div className="newsletter-message1">{subsFormContent().title}</div>
              <div className="newsletter-message2">{subsFormContent().subTitle}</div>
            </div>
            <div className="newsletter-inputs">
              <div className="newsletter-email">
                <div className="newsletter-email-text">{t('Common_Email')}*</div>
                <input
                  aria-label="Stay Connected Form Email input"
                  className={'newsletter-email-field' + (error ? ' newsletter-email-field-invalid' : '')}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="email@email.com"
                  aria-describedby="emailValidationField"
                  value={email}
                  onKeyPress={async (e) => e.key === 'Enter' && (await handleSubscribe())}
                  aria-invalid={error ? 'true' : 'false'}
                />
                {error ? (
                  <span className="validation-message" id="emailValidationField" role="alert">
                    {error}
                  </span>
                ) : null}
                <label htmlFor="hp-input" aria-hidden hidden>
                  hp
                </label>
                <input id="hp-input" aria-hidden hidden className="honeypot-email" />
              </div>
              <div className="newsletter-status">
                <label htmlFor={selectId}>
                  <p className="newsletter-status-text">{t('Common_status')}*</p>
                </label>
                <select
                  tabIndex={0}
                  aria-label="Stay Connected Form Status Change"
                  className="newsletter-status-select"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  {subsFormContent().status.map((s, i) => (
                    <option key={`${s}-${i}`}>{subsFormContent().displayValue[s]}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="newsletter-button">
              <button className="newsletter-subscribe-button" onClick={async () => await handleSubscribe()}>
                {t('Common_subscribe')}
              </button>
            </div>
          </div>
        </div>
      </>
    ),
    [email, handleSubscribe, status, subsFormContent, t, locale, error]
  )
}

export default NewsletterSubsForm
